import Div from "../common/components/div";
import H1 from "../common/components/h1";
import translate from "../common/functions/translate";

export const MfaNotAvailable = () => {
    return (
        <Div isContainer>
            <Div isRow>
                <Div cols={12}>
                    <H1>{translate("not_available")}</H1>
                </Div>
            </Div>
        </Div>
    );
};